(function () {
  'use strict';
  const script = document.currentScript;
  const enabled = script?.dataset.enabled === 'true';
  const storeKey = script?.dataset.storeKey || location.hostname;
  const windowDays = Number(script?.dataset.windowDays || 0);
  const code = new URL(location.href).searchParams.get('ref');
  if (!enabled || !code || !Number.isInteger(windowDays) || windowDays < 1) return;
  const normalized = String(code).trim().toUpperCase().replace(/[^A-Z0-9_-]/g, '').slice(0, 24);
  if (!normalized) return;
  const key = `commerce:${storeKey}:attribution:v1`;
  const now = Date.now();
  try {
    const current = JSON.parse(localStorage.getItem(key) || 'null');
    if (current && current.expires_at > now) return;
    localStorage.setItem(key, JSON.stringify({ referral_code: normalized, attributed_at: now, expires_at: now + windowDays * 86400000, first_party: true, candidate_only: true }));
    document.dispatchEvent(new CustomEvent('commerce:referral-captured', { detail: { referralCode: normalized, candidateOnly: true } }));
  } catch (error) {}
})();

